<template>
  <div class="popup-standard">
    <full-popup
      :title="props.title ?? ''"
      :is-close-button="isCloseButton"
      :is-back-button="isBackButton"
      @on-click-back="onCancel"
      @on-click-close="onCancel"
    >
      >
      <template #contents>
        <component
          :is="component"
          v-if="component"
          :key="`modal__standard__${component.name}`"
          :payloads="payloads"
          @on-confirm="onConfirm"
          @on-cancel="emit('on-cancel')"
        >
        </component>
      </template>
    </full-popup>
  </div>
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import FullPopup from '@/components/ui/FullPopup.vue'
  import StandardContent from '@/views/popup/fragments/StandardContent.vue'
  import { EventBus } from '@/components/eventbus/EventBus'
  import { POPUP_STANDARD_CONFIRM } from '@/common/resources/const'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })
  const emit = defineEmits(['on-confirm', 'on-cancel'])

  const component = computed(() => props.payloads?.component ?? StandardContent)
  const isCloseButton = computed(() => props.payloads?.isCloseButton ?? false)
  const isBackButton = computed(() => props.payloads?.isBackButton ?? false)

  const onConfirm = () => {
    EventBus.$emit(POPUP_STANDARD_CONFIRM, {
      isSuccess: true,
      payloads: props.payloads,
    })
  }

  const onCancel = () => {
    emit('on-cancel')
  }
</script>
